module.exports = __webpack_public_path__ + "static/assets/3ffcb2133b49c751d064019f2ed071ed.png";